<script setup lang="ts">
import { WangsIcons } from 'lib/components/icon/Icon.vue.d';

import { MenuItem } from '.';
import Icon from '../icon/Icon.vue';
import { MenuRouterBindProps } from '../menu/Menu.vue.d';

const props = defineProps<{
  item: MenuItem;
  routerProps: MenuRouterBindProps;
}>();
</script>

<template>
  <router-link
    #default="{ href, navigate }"
    v-if="props.item.route"
    :to="props.item.route"
    custom
  >
    <a :href="href" v-bind="routerProps?.action" @click="navigate">
      <Icon
        v-if="props.item.icon"
        v-bind="routerProps?.icon"
        :icon="props.item.icon as WangsIcons"
      />

      <span v-bind="routerProps?.label">{{ props.item.label }}</span>
    </a>
  </router-link>

  <a
    v-else-if="props.item.url"
    :href="props.item.url"
    :target="props.item.target"
    v-bind="routerProps?.action"
    @click.stop
  >
    <Icon
      v-if="props.item.icon"
      v-bind="routerProps?.icon"
      :icon="props.item.icon as WangsIcons"
    />

    <span v-bind="routerProps?.label">{{ props.item.label }}</span>
  </a>

  <a
    v-else
    v-bind="routerProps?.action"
    aria-hidden="true"
    data-pc-section="action"
    tabindex="-1"
  >
    <Icon
      v-if="props.item.icon"
      :icon="props.item.icon as WangsIcons"
      :severity="props.item.danger ? 'danger' : undefined"
      v-bind="routerProps?.icon"
    />

    <span
      v-bind="
        $preset.menu?.label({
          props: { danger: props.item.danger },
        })
      "
      data-pc-section="label"
    >
      {{ props.item.label }}
    </span>
  </a>
</template>
